module.exports = __webpack_public_path__ + "static/media/Logo.183dfba7.png";